import { useAppSelector } from '../store/hooks';
import i18n from 'src/i18n';

export const useIsRTL = () => {
  const language = useAppSelector(state => state.main.language);

  return i18n.dir(language) === 'rtl';
};
